// TopicalCard.jsx
import React, { useState } from "react";
import { Box, Flex, Text, IconButton, Button, HStack, VStack, useBreakpointValue, Image  } from "@chakra-ui/react";
import ButtonUpChevron from "../Images/Button-Up-Chevron-icon-Stande2.0.svg";
import ButtonDownChevron from "../Images/Bottom-Chevron-Icon-Stande2.0.svg";
import ArrowRight from "../Images/Arrow-Right-icon-Stande2.0.svg";
import MinusIcon from "../Images/Minimis/Minus-Icon-Stande2.0.svg";
import SolveIcon from "../Images/Solve-Icon-Stande2.0.svg";
import { a } from "./appColors";

const Row = ({ label, onSolve }) => {
  const [open, setOpen] = useState(false);
  return (
    <VStack align="start" spacing="8px" w="100%">
      <Flex
        w={{ base: "100%", sm: "565px" }}
        h="39px"
        px="6px"
        py="7px"
        justify="space-between"
        align="center"
        gap="407px"
        borderBottom="1px solid" borderBottomColor={a.border}
        bg={a.surface}
        borderRadius="6px"
        _hover={{ bg: a.hover }}
        cursor="pointer"
        onClick={() => setOpen(s => !s)}


      >
        <Text color={a.text2} fontSize="14px" fontWeight="400" lineHeight="normal">{label}</Text>
        <IconButton
          aria-label={open ? "Collapse" : "Expand"}
          minW="24px"
          h="24px"
          bg="transparent"
          borderRadius="full"
          _hover={{ bg:"#ffffff"}}
          icon={<Box as="img" src={open ? MinusIcon : ArrowRight} alt="" w="16px" h="16px" />}
        />
      </Flex>

      {open && (
        <HStack spacing="8px" pl="6px">
          <Button
            onClick={onSolve}
            variant="ghost"
            px="8px"
            py="4px"
            borderRadius="24px"
            border="0.5px solid" borderColor={a.border}
            bg={a.materialBg}
            _hover={{ opacity: 0.85 }}
            leftIcon={<Box as="img" className="material-icon" src={SolveIcon} alt="" w="16px" h="16px" />}
          >
            <Text color={a.materialText} fontSize="14px" fontWeight="400" lineHeight="normal">Solve Online</Text>
          </Button>
        </HStack>
      )}
    </VStack>
  );
};

const TopicalCard = ({ title, items, onSolveRow }) => {
  const [open, setOpen] = useState(false);
  const containerW = useBreakpointValue({ base: "100%", md: "661px" });

  return (
    <Box w={containerW}>
      <Flex
        w="100%"
        h="70px"
        px="33px"
        pt="18px"
        pb="24px"
        justify="space-between"
        align="center"
        gap="24px"
        borderRadius="14px"
        border="1px solid" borderColor={a.border}
        bg={a.surface}
        onClick={() => setOpen(s => !s)}
        cursor="pointer"
      >
        <Text color={a.text2} fontFamily='"Mona Sans", sans-serif' fontSize="18px" fontWeight="500" lineHeight="normal">
          {title}
        </Text>
        <Image
              src={open ? ButtonUpChevron : ButtonDownChevron}
              alt=""
              w="20px"
              h="20px"
            /> 
      </Flex>

      {open && (
        <Box mt="16px" w="100%" p={{ base: "12px", md: "16px 24px" }} borderRadius="14px" border="1px solid" borderColor={a.border} bg={a.surface}>
          <VStack align="start" spacing="8px">
            {items.map((it, idx) => (
              <Row key={it.id ?? idx} label={it.label} onSolve={() => onSolveRow?.(it)} />
            ))}
          </VStack>
        </Box>
      )}
    </Box>
  ); 
};

export default TopicalCard;
